import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=97c2393a&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=ts&"
export * from "./Contacts.vue?vue&type=script&lang=ts&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=97c2393a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c2393a",
  null
  
)

export default component.exports